import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import ProductGroupForm from './ProductGroupForm';
import FormToolbar from '../shared/FormToolbar';

const ProductGroupEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ProductGroupForm {...props} />
    </SimpleForm>
  </Edit>
);

export default ProductGroupEdit;
